import { serviceName } from '../resources/serviceConstants';
import { appendServiceNameToURL, appendServicePortToURL } from '../resources/serviceURLs';
import { SALARY_REPORT, SALARY_REPORT_FILTER_OPTIONS } from '../resources/endPoint';

export const buildSalaryReportApiUrl = (path) => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${path}`;
  }
  return `${baseUrl}:${servicePort}${serviceURL}/api${path}`;
};

export const getSalaryReportFilterOptions = () => ({
  url: SALARY_REPORT_FILTER_OPTIONS,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: true,
  service: serviceName.PROJECT_MS,
});

export const getSalaryReportData = (payload) => ({
  url: SALARY_REPORT,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: true,
  payload,
  service: serviceName.PROJECT_MS,
});
